<template>
  <b-tabs
    v-if="userData != null"
    vertical
    content-class="col-12 col-md-9 mt-1 mt-md-0"
    pills
    nav-wrapper-class="col-md-3 col-12"
    nav-class="nav-left"
  >

    <!-- general tab -->
    <b-tab active>
      <template #title>
        <feather-icon
          icon="UserIcon"
          size="18"
          class="mr-50"
        />
        <span class="font-weight-bold">{{ $t('General') }}</span>
      </template>

      <account-setting-general :user-data.sync="userData" />
    </b-tab>
    <!--/ general tab -->

    <!-- change password tab -->
    <b-tab>
      <template #title>
        <feather-icon
          icon="LockIcon"
          size="18"
          class="mr-50"
        />
        <span class="font-weight-bold">{{ $t('Change Password') }}</span>
      </template>

      <account-setting-password :user-data.sync="userData" />
    </b-tab>
    <!--/ change password tab -->

    <!-- info -->
    <b-tab>
      <template #title>
        <feather-icon
          icon="InfoIcon"
          size="18"
          class="mr-50"
        />
        <span class="font-weight-bold">{{ $t('Roles') }} & {{ $t('Permissions') }}</span>
      </template>

      <account-setting-information :user-data.sync="userData" />
    </b-tab>

    <!-- social links -->
    <b-tab>
      <template #title>
        <feather-icon
          icon="LinkIcon"
          size="18"
          class="mr-50"
        />
        <span class="font-weight-bold">{{ $t('Social') }}</span>
      </template>

      <account-setting-social :user-data.sync="userData" />
    </b-tab>

    <!-- notification -->
    <!-- <b-tab>
      <template #title>
        <feather-icon
          icon="BellIcon"
          size="18"
          class="mr-50"
        />
        <span class="font-weight-bold">{{ $t('Notifications') }}</span>
      </template>

      <account-setting-notification
        v-if="options.notification"
        :notification-data="options.notification"
      />
    </b-tab> -->
  </b-tabs>
</template>

<script>
import { BTabs, BTab } from 'bootstrap-vue'
import useJwt from '@/auth/jwt/useJwt'
import AccountSettingGeneral from './AccountSettingGeneral.vue'
import AccountSettingPassword from './AccountSettingPassword.vue'
import AccountSettingInformation from './AccountSettingInformation.vue'
import AccountSettingSocial from './AccountSettingSocial.vue'
// import { ref } from '@vue/composition-api';
// import AccountSettingNotification from './AccountSettingNotification.vue'
// import useAccount from './useAccount';

export default {
  components: {
    BTabs,
    BTab,
    AccountSettingGeneral,
    AccountSettingPassword,
    AccountSettingInformation,
    AccountSettingSocial,
    // AccountSettingNotification,
  },
  data() {
    return {
      options: {},
      update_type: 'info',
    }
  },
  computed: {
    userData(newVal, oldVal) {
      return this.$store.state.auth.user;
    },
  },
  mounted() {
  },

}
</script>
